import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: null,
};

export const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    setSelectedMerchant: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedMerchant } = merchantSlice.actions;

export default merchantSlice.reducer;
